<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!-- <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item> -->


      <el-form-item label="如果用户没设置封面，封面显示类型" prop="is_coupon">
        <el-radio-group v-model="form.logo_type">
            <!-- <el-radio :label="1">视频第一帧</el-radio> -->
            <el-radio :label="2">系统默认封面</el-radio>
          </el-radio-group>
      </el-form-item>


      <el-form-item label="动态默认封面" prop="describe">
        <div v-if="form.logo.file_path" class="default-image-box" @click="isAboutLogoUpload = true">
          <div class="image-box">
            <img :src="form.logo.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteLogoImg">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutLogoUpload = true"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>


    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->

  < <Upload v-if="isAboutLogoUpload" :config="{ total:1 }" :isupload="isAboutLogoUpload" @returnImgs="returnLogoImgsFunc">上传图片</Upload>


</div>
</template>
<script>
import NotesApi from '@/api/notes.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isAboutLogoUpload:false,
      isAboutBannerUpload:false,
      form: {
        status: false,
        logo: {
          file_id: '',
          file_path: ''
        },
        logo_type:2
      },
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
        // 删除logo图片
        deleteLogoImg() {
      this.form.logo = {
        file_id: '',
        file_path: ''
      }
    },
        // 上传logo图片
        returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.logo.file_id = e[0].file_id
        this.form.logo.file_path = e[0].file_path
      }
      this.isAboutLogoUpload = false
    },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      NotesApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
            if(!self.form.logo){
              self.form.logo =  {
                  file_id: '',
                  file_path: ''
                };
            }
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      NotesApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/setting/getSetting.vue